import { Box, Button, Form, TextInput, Text, Image, Stack, Anchor } from "grommet";
import React, { useEffect } from "react";

import axios from "../general/HttpClient";
import { useNavigate, useParams } from "react-router-dom";

import SkeletonWrapper from "../components/SkeletonWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StyledModal from "../components/StyledModal";

const View = () => {
    const { id } = useParams();

    const [subject, setSubject] = React.useState({} as any);
    const [loading, setLoading] = React.useState(true);
    const [welcomeModal, setWelcomeModal] = React.useState(false);

    const [files, setFiles] = React.useState([] as any[]);

    useEffect(() => {
        load();
    }, [id]);

    const load = async () => {
        let response = await axios.get("/api/Subject/" + id);
        if (response.data) {
            setSubject(response.data);
            setLoading(false);

            let files = [] as any[];

            for (let i = 0; i < response.data.sharePhotos.length; i++) {
                let blob = await fetch(response.data.sharePhotos[i]).then((res) => res.blob());
                files.push(new File([blob], response.data.name + "_" + (i + 1) + ".png", { type: "image/png" }));
            }

            setFiles(files);
        }
    };

    const download = (file: File) => {
        const url = window.URL.createObjectURL(file);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        // the filename you want
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <SkeletonWrapper loading={loading}>
            <Box pad={"small"} round="10px" align="center">
                <Image src="/logo.png" width={"500px"}></Image>
                <Anchor href="https://linktr.ee/rgbgaming" color={"brand"}>
                    Learn more about us
                </Anchor>
                <Text size="large">{subject.name}</Text>
                <Box gap="small" pad={"xsmall"} align="center">
                    {subject.sharePhotos?.map((sharePhoto, i) => (
                        <Stack key={sharePhoto} anchor="top-left">
                            <Image src={sharePhoto} style={{ maxWidth: "100%", maxHeight: "500px" }}></Image>
                            <Box direction="row" justify="between">
                                <Button icon={<FontAwesomeIcon icon="share" />} primary style={{ borderRadius: "100%", margin: "1rem" }} onClick={() => navigator.share({ files: [files[i]] })}></Button>
                                <Button icon={<FontAwesomeIcon icon="download" />} primary style={{ borderRadius: "100%", margin: "1rem" }} onClick={() => download(files[i])}></Button>
                            </Box>
                        </Stack>
                    ))}
                </Box>
                <Button label="My Data" onClick={() => setWelcomeModal(true)}></Button>

                <StyledModal isOpen={welcomeModal} setIsOpen={() => setWelcomeModal(false)}>
                    <Box width={{ min: "medium" }} gap="small">
                        <Text>We only store photos, no additional information about you is collected or stored.</Text>
                        <Text>We do not use cookies or any other tracking methods.</Text>
                        <Text>We do not share your data with anyone.</Text>
                        <Text>All data including photos will be deleted after the event.</Text>
                        <Text>If you would like to have your data deleted at an earlier time, please contact us.</Text>
                        <Anchor href="https://linktr.ee/rgbgaming" color={"brand"}>
                            Learn more about us
                        </Anchor>
                    </Box>
                    <Button label="Close" onClick={() => setWelcomeModal(false)}></Button>
                </StyledModal>
            </Box>
        </SkeletonWrapper>
    );
};

export default View;
